export const COMMON_MAX_PAGE_SIZE = 100;
